import en from './En'
import kr from './Kr'

export default { en, kr }
